import { render, staticRenderFns } from "./SGPCustomTagsComponent.vue?vue&type=template&id=2105dc53"
import script from "./SGPCustomTagsComponent.vue?vue&type=script&lang=js"
export * from "./SGPCustomTagsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports